import type { FC, HTMLAttributes } from 'react'
import { HBox } from '../layout/horizontal-box.js'
import styles from './pulse.module.css'

export interface PulseProps {
  size?: 'small' | 'medium' | 'large'
  placeholder?: string
}

interface BlobProps extends HTMLAttributes<HTMLDivElement> {
  size: 'small' | 'medium' | 'large'
}

const Blob = ({ size, ...props }: BlobProps) => {
  const scale = size === 'small' ? 0.5 : size === 'medium' ? 1 : 2
  return (
    <div
      {...props}
      className={styles.blob}
      style={{
        height: 16 * scale,
        width: 16 * scale,
        ...props.style,
      }}
    />
  )
}

export const Pulse: FC<PulseProps> = ({ size = 'small', placeholder }) => (
  <HBox>
    <Blob size={size} />
    {placeholder ? (
      <span className={styles.placeholder}>
        {placeholder}
      </span>
    ) : null}
  </HBox>
)

export { Pulse as PulseProgress }
export default Pulse
